import TextAnalysis from "./textAnalysis";

interface PostTextPreviewProps {
  postText: string;
  onChange: (value: string) => void;
}

export default function PostTextPreview({
  postText,
  onChange,
}: PostTextPreviewProps) {
  return (
    <div className="post-text-preview">
      <textarea className="textarea-primary"
        value={postText}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Der generierte Social-Media-Text erscheint hier..."
    />

      {postText && (<TextAnalysis postText={postText} />)}
    </div>
  );
}